import { getConfig } from "utils/env";
import pick from "lodash/pick";
import isEmpty from "lodash/isEmpty";
import QS from "qs";
import { ENV } from "./constants/env";
const CHECKOUT_SESSION_KEYS = [
  "session",
  "customer",
  "customer_email",
  "client_reference_id",
  "metadata",
  "success_url"
];

export const getWebClientRoot = () =>
  getConfig("WEB_CLIENT_ROOT").split("://")[1];

export const subdomainParamsFromReq = ({ req, route }) => {
  const result = {};
  if (route) {
    result.route = route;
  }
  const { headers, url } = req;
  if (headers && headers.host) {
    const { host } = headers;
    const webClientRoot = getWebClientRoot();
    const checkout = getPriceCheckoutSessionParams(url);
    if (!isEmpty(checkout)) {
      result.checkout = checkout;
    }

    /**
     * In development if we are on the root domain then subdomain default is the app subdomain
     */
    if (process.env.NODE_ENV !== ENV.PRODUCTION && host === webClientRoot) {
      result.subdomain = getConfig("APP_SUBDOMAIN");
      return result;
    } else {
      const subdomainParts = host.split(".");
      const sliceCount = subdomainParts.length > 3 ? 2 : 1;
      const target = subdomainParts.slice(0, sliceCount).join(".");
      const protocolParts = target.split("://");

      result.subdomain =
        protocolParts.length > 1 ? protocolParts[1] : protocolParts[0];

      return result;
    }
  }
};

export const getPriceCheckoutSessionParams = (url) => {
  const qsParams = url && url.split("?")[1];
  const params = qsParams ? QS.parse(qsParams) : {};
  return pick(params, CHECKOUT_SESSION_KEYS);
};

export const isPlatformSubdomain = (subdomain) =>
  subdomain && subdomain === getConfig("APP_SUBDOMAIN");

export const getSubdomainRoot = (subdomain, env = process.env.NODE_ENV) => {
  const protocol = env === ENV.PRODUCTION ? `https://` : "http://";
  const webClientRoot = getWebClientRoot();
  const ctxSubdomain = isPlatformSubdomain(subdomain) ? "" : `${subdomain}.`;
  return `${protocol}${ctxSubdomain}${webClientRoot}`;
};

export const getGenericSubdomainRoot = (url) => {
  const subdomain = url.split("://")[1];
  return subdomain ? subdomain.split(".")[0] : "";
};
